import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { PublicRoutingModule } from './public-routing.module';
import { PublicIndexComponent } from './public-index/public-index.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { PublicHomeComponent } from './public-home/public-home.component';
import { MatMenuModule } from '@angular/material/menu';
import { RegistrationComponent } from './registration/registration.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginComponent } from './login/login.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { AccountDeactiveComponent } from './account-deactive/account-deactive.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CoreModule } from '../core/core.module';
import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { CommonSharedModule } from '../shared/shared.module';
import { PublicSharedModule } from './shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReturningUserResetPasswordComponent } from './returning-user-reset-password/returning-user-reset-password.component';

@NgModule({
  declarations: [
    PublicIndexComponent,
    PublicHomeComponent,
    RegistrationComponent,
    ThankyouComponent,
    ResetPasswordComponent,
    LoginComponent,
    ForgetPasswordComponent,
    AccountDeactiveComponent,
    ChangePasswordComponent,
    ReturningUserResetPasswordComponent,
  ],
  imports: [
    CommonModule,
    PublicRoutingModule,
    MatInputModule,
    MatSelectModule,
    CarouselModule.forRoot(),
    SlickCarouselModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    CommonSharedModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgxMatIntlTelInputModule,
    CoreModule,
    PublicSharedModule,
    MatTooltipModule,
  ],
  entryComponents: [
    RegistrationComponent,
    ThankyouComponent,
    ResetPasswordComponent,
    LoginComponent,
    ForgetPasswordComponent,
  ],
  providers: [BsModalRef],
})
export class PublicModule {}
